/**
 * Rule
 * - use lowercase or lower camelCase
 */

const config={
  global:{
    getApi: '/data/get-global',
  },
  payment:{
    getApi: '/data/get-info',
    setApi: '/api/payments',
    fields: {
      name: {
        name: "name",
        label: "お名前 (ローマ字)",
        options: {
          rules: [{
            required: true,
            message: 'お名前を入力してください',
          },{
            type: 'string',
//            required: true,
            pattern: /^[\x01-\x7E]+$/,
            message: '半角ローマ字でお名前をご入力ください',
          }],
        }
      },
      email: {
        name: "email",
        label: "Eメールアドレス",
        options: {
          rules: [{
            type: 'email',
            message: '有効なEメールアドレスを入力してください',
          }, {
            required: true,
            message: 'Eメールアドレスを入力してください',
          }],
        }
      },
      phone: {
        name: "phone",
        label: "お電話",
        options: {
        }
      },
      enquiry: {
        name: "enquiry",
        label: "支払い目的",
        options: {
        }
      },
      recurring: {
        name: "recurring",
        label: "recurring",
        options: {}
      },
      address: {
        name: "address",
        label: "住所",
        options: {}
      },
      state: {
        name: "state",
        label: "State",
        options: {},
        items: [
          {key: 'nsw', label: 'NSW'},
          {key: 'qld', label: 'QLD'},
          {key: 'vic', label: 'VIC'},
        ]
      },
      postcode: {
        name: "postcode",
        label: "Postcode",
        options: {
          rules: [{
            required: true,
            message: 'Please input postcode',
          }],
        }
      },
      amount: {
        name: "amount",
        label: "合計金額",
        options: {
          rules:[{
          required: true,
          message: '金額を入力してください',
          }]
        },
      },
      payment: {
        name: "payment",
        label: "カード情報",
        options: {},
      },
    },
    stripeStyle:{
      base: {
        color: '#303238',
        fontSize: '18px',
        lineHeight: '52px',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#ccc',
        }
      },
      empty: {
        color: '#e5424d',
        ':focus': {
          color: '#303238',
        },
        '::placeholder': {
          color: '#e5424d',
        },
      },
      invalid: {
        color: '#e5424d',
        ':focus': {
          color: '#303238',
        },
        '::placeholder': {
          color: '#e5424d',
        },
      },
    }
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/pages/payment/config/config.js